export const ObservedRainfallMapConstants = {
    CommonLayers : [
        {
            layerNameType : 'STATE',
            serviceType : 'WmsLayer',
            view : 'Both',
            type : 'Base',
            env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
            pane : 'popup',
            // styles:'ALL_INDIA_STATE_NAMES',
            styles:'INDIA_STATE_NAMES',
            maxZoom:7
          },
          {
            layerNameType : 'MASK_LAYER',
            serviceType : 'WmsLayer',
            name : 'stateMask',
            view : 'Both',
            type : 'Inverse',
            env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
            pane : 'mask',
            styles:'HEATWAVE:world_view_white,HEATWAVE:inverse_mask',
          },
          {
            layerNameType : 'DISTRICT',
            serviceType : 'VectorLayer',
            view : 'Both',
            type : 'Base',
            interactive : true,
            env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
            pane : 'district',
            styles:'INDIA_DISTRICT_NAMES',
            minZoom:8,
            maxZoom:9
          },
          {
            layerNameType : 'DISTRICT',
            serviceType : 'WmsLayer',
            view : 'Both',
            type : 'Base',
            env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
            pane : 'district',
            styles:'INDIA_DISTRICT_NAMES_ACTUAL',
            minZoom:7,
            maxZoom:9
          },
          {
            layerNameType : 'BLOCKS',
            serviceType : 'WmsLayer',
            view : 'Both',
            type : 'Base',
            env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
            pane : 'village',
            styles:'ALL_INDIA_BLOCK_NAMES_ACTUAL',
            minZoom:9
          },
    //     {
    //     layerNameType : 'FORECAST_ADMIN_WITH_MASK',
    //     serviceType : 'WmsLayer',
    //     view : 'Admin',
    //     type : 'Base',
    //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //   },
    //   {
    //     layerNameType : 'BLOCK',
    //     serviceType : 'WmsLayer',
    //     view : 'Admin',
    //     type : 'Base',
    //     name : 'blockLayer',
    //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     minZoom : 9
    //   },
    //   {
    //     layerName : 'forecast:BASIN_INVERSE',
    //     serviceType : 'WmsLayer',
    //     view : 'Basin',
    //     type : 'Inverse',
    //     name : 'basinMask',
    //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     hidelayer : true,
    //     zIndex : 'district'
    //   },
    //   {
    //     layerNameType : 'FORECAST_BASIN_WITH_MASK',
    //     serviceType : 'WmsLayer',
    //     view : 'Basin',
    //     type : 'Base',
    //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     zIndex : 'state'
    //   },
    //   {
    //     layerNameType : 'SUBBASIN',
    //     serviceType : 'WmsLayer',
    //     view : 'Basin',
    //     type : 'Base',
    //     name : 'blockLayer',
    //     env :'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     minZoom : 9,
    //     zIndex : 'state'
    //   },
    //   {
    //     layerNameType : 'DISTRICT',
    //     serviceType : 'VectorLayer',
    //     view : 'Admin',
    //     type : 'Base',
    //     interactive : false,
    //     locationName : 'district'

    //   },
    //   {
    //     layerNameType : 'BASIN',
    //     serviceType : 'VectorLayer',
    //     view : 'Basin',
    //     type : 'Base',
    //     interactive : false,
    //     env :'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#000000;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.6;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#ffffff;b_s_color:#000000',
    //     locationName : 'basin'
    //   },
    //   {
    //     layerNameType : 'BLOCK',
    //     serviceType : 'VectorLayer',
    //     view : 'Admin',
    //     type : 'Base',
    //     interactive : true,
    //     locationName : 'block'

    //   },
    //   {
    //     layerName : 'forecast:AP_VILLAGE',
    //     serviceType : 'WmsLayer',
    //     view : 'Admin',
    //     type : 'Base',
    //     name : 'villageLayer',
    //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     minZoom: 12
    //   },
    //   {
    //     layerNameType : 'SUBBASIN',
    //     serviceType : 'VectorLayer',
    //     view : 'Basin',
    //     type : 'Base',
    //     interactive : true,
    //     env :'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     locationName : 'sub_basin'
    //   }
    ],


    HeatMapOptions : {
      type : 'Time',
      view : 'Admin',
      serviceType : 'HeatMap'
    },
    RasterMapOptions : {
        type : 'Time',
        view : 'Admin',
        serviceType : 'Raster'
      },

    HeatMapUrl : 'rf/heatmap',
    RasterMapUrl : 'rf/heatmap',


    CroppedHeatMapOptions : {
        type : 'Time',
        view : 'Admin',
        serviceType : 'CroppedHeatMap'
    },

    GeoJsonOptions : {
      type : 'Time',
      view : 'Admin',
      serviceType : 'GeoJsonMarker',
      pane : 'state'
    },

    // Legend:{
    //     colorValues: [
    //     {
    //         backgroundColor : '#000000',
    //         color : '#000000',
    //         text : '0'
    //     },
    //     {
    //         backgroundColor : '#C3FDCA',
    //         color : '#000000',
    //         text : '0.1'
    //     },
    //     {
    //         backgroundColor : '#01FF04',
    //         color : '#000000',
    //         text : '2.5'
    //     },
    //     {
    //         backgroundColor : '#048500',
    //         color : '#000000',
    //         text : '15.6'
    //     },
    //     {
    //         backgroundColor : '#FDC0CB',
    //         color : '#000000',
    //         text : '64.5'
    //     },
    //     {
    //         backgroundColor : '#FC0300',
    //         color : '#000000',
    //         text : '115.6'
    //     },
    //     {
    //         backgroundColor : '#610301',
    //         color : '#000000',
    //         text : '>204.5'
    //     }
    // ],  
    // Units : 'mm', 
    // },

   /* Legend : {
      'LOW' : {
        colorValues: [
          {
              backgroundColor : '#FC9994',
              color : '#000000',
              text : '0'
          },
          {
              backgroundColor : '#FFC298',
              color : '#000000',
              text : '50'
          },
          {
              backgroundColor : '#FFEEA1',
              color : '#000000',
              text : '100'
          },
          {
              backgroundColor : '#E6FEB6',
              color : '#000000',
              text : '150'
          },
          {
              backgroundColor : '#BDFEE1',
              color : '#000000',
              text : '200'
          },
          {
              backgroundColor : '#97F5FD',
              color : '#000000',
              text : '250'
          },
          {
              backgroundColor : '#9BC2FF',
              color : '#000000',
              text : '350'
          },
          {
            backgroundColor : '#9A98FF',
            color : '#000000',
            text : '>600'
          }
      ],  
      Units : 'mm',
      },
      'MED' : {
        colorValues: [
          {
              backgroundColor : '#FC9994',
              color : '#000000',
              text : '0'
          },
          {
              backgroundColor : '#FFC298',
              color : '#000000',
              text : '300'
          },
          {
              backgroundColor : '#FFEEA1',
              color : '#000000',
              text : '500'
          },
          {
              backgroundColor : '#E6FEB6',
              color : '#000000',
              text : '700'
          },
          {
              backgroundColor : '#BDFEE1',
              color : '#000000',
              text : '900'
          },
          {
              backgroundColor : '#97F5FD',
              color : '#000000',
              text : '1500'
          },
          {
              backgroundColor : '#9BC2FF',
              color : '#000000',
              text : '3000'
          },
          {
            backgroundColor : '#9A98FF',
            color : '#000000',
            text : '>3500'
          }
      ],  
      Units : 'mm',
      },
      'HIGH' : {
        colorValues: [
          {
              backgroundColor : '#FC9994',
              color : '#000000',
              text : '0'
          },
          {
              backgroundColor : '#FFC298',
              color : '#000000',
              text : '1500'
          },
          {
              backgroundColor : '#FFEEA1',
              color : '#000000',
              text : '2000'
          },
          {
              backgroundColor : '#E6FEB6',
              color : '#000000',
              text : '2500'
          },
          {
              backgroundColor : '#BDFEE1',
              color : '#000000',
              text : '3000'
          },
          {
              backgroundColor : '#97F5FD',
              color : '#000000',
              text : '3500'
          },
          {
              backgroundColor : '#9BC2FF',
              color : '#000000',
              text : '4000'
          },
          {
            backgroundColor : '#9A98FF',
            color : '#000000',
            text : '>5000'
          }
      ],  
      Units : 'mm',
      }
    } */

  Legend : {
      'LOW' : {
        colorValues: [
        {
            backgroundColor : '#FFFFFF',
            color : '#000000',
            text : '0'
        },
        {
            backgroundColor : '#C3FDCA',
            color : '#000000',
            text : '0.1'
        },
        {
            backgroundColor : '#01FF04',
            color : '#000000',
            text : '2.5'
        },
        {
            backgroundColor : '#048500',
            color : '#FFFFFF',
            text : '15.6'
        },
        {
            backgroundColor : '#FDC0CB',
            color : '#FFFFFF',
            text : '64.5'
        },
        {
            backgroundColor : '#FC0300',
            color : '#FFFFFF',
            text : '115.6'
        },
        {
            backgroundColor : '#610301',
            color : '#FFFFFF',
            text : '>204.5'
        }
    ],
    Units : 'mm',
      },
      'MED' : {
        colorValues: [
        {
            backgroundColor : '#FFFFFF',
            color : '#000000',
            text : '0'
        },
        {
            backgroundColor : '#C3FDCA',
            color : '#000000',
            text : '0.1'
        },
        {
            backgroundColor : '#01FF04',
            color : '#000000',
            text : '2.5'
        },
        {
            backgroundColor : '#048500',
            color : '#FFFFFF',
            text : '15.6'
        },
        {
            backgroundColor : '#FDC0CB',
            color : '#FFFFFF',
            text : '64.5'
        },
        {
            backgroundColor : '#FC0300',
            color : '#FFFFFF',
            text : '115.6'
        },
        {
            backgroundColor : '#610301',
            color : '#FFFFFF',
            text : '>204.5'
        }
    ],
    Units : 'mm',
      },
      'HIGH' : {
        colorValues: [
        {
            backgroundColor : '#FFFFFF',
            color : '#000000',
            text : '0'
        },
        {
            backgroundColor : '#C3FDCA',
            color : '#000000',
            text : '0.1'
        },
        {
            backgroundColor : '#01FF04',
            color : '#000000',
            text : '2.5'
        },
        {
            backgroundColor : '#048500',
            color : '#FFFFFF',
            text : '15.6'
        },
        {
            backgroundColor : '#FDC0CB',
            color : '#FFFFFF',
            text : '64.5'
        },
        {
            backgroundColor : '#FC0300',
            color : '#FFFFFF',
            text : '115.6'
        },
        {
            backgroundColor : '#610301',
            color : '#FFFFFF',
            text : '>204.5'
        }
    ],
    Units : 'mm',
      },
    //   'CURRENT_DATE' : {
    //     colorValues: [
    //     {
    //         backgroundColor : '#FFFFFF',
    //         color : '#000000',
    //         text : '0-0.1'
    //     },
    //     {
    //         backgroundColor : '#C3FDCA',
    //         color : '#000000',
    //         text : '0.1-2.4'
    //     },
    //     {
    //         backgroundColor : '#01FF04',
    //         color : '#000000',
    //         text : '2.5-15.5'
    //     },
    //     {
    //         backgroundColor : '#048500',
    //         color : '#FFFFFF',
    //         text : '15.6-64.4'
    //     },
    //     {
    //         backgroundColor : '#FDC0CB',
    //         color : '#FFFFFF',
    //         text : '64.5-115.5'
    //     },
    //     {
    //         backgroundColor : '#FC0300',
    //         color : '#FFFFFF',
    //         text : '115.6-204.4'
    //     },
    //     {
    //         backgroundColor : '#610301',
    //         color : '#FFFFFF',
    //         text : '>204.4'
    //     }
    // ],
    // Units : 'Rainfall in mm',
    //   },
      'CURRENT_DATE' : {
        colorValues: [
        {
            backgroundColor : '#DEDEDD',
            color : '#000000',
            text : '0.0-0.1'
        },
        {
            backgroundColor : '#D1FCC4',
            color : '#000000',
            text : '0.2-2.5'
        },
        {
            backgroundColor : '#97E994',
            color : '#000000',
            text : '2.6-15.5'
        },
        {
            backgroundColor : '#048500',
            color : '#FFFFFF',
            text : '15.6-64.5'
        },
        {
            backgroundColor : '#FDA3A5',
            color : '#FFFFFF',
            text : '64.6-115.6'
        },
        {
            backgroundColor : '#FEBF02',
            color : '#FFFFFF',
            text : '115.7-204.5'
        },
        {
            backgroundColor : '#6BC8D1',
            color : '#FFFFFF',
            text : '204.6-250.1'
        },
        {
            backgroundColor : '#AFA5FC',
            color : '#FFFFFF',
            text : '250.2-300.1'
        },
        {
            backgroundColor : '#9C34C7',
            color : '#FFFFFF',
            text : '>300.1'
        }
    ],
    Units : 'Rainfall in mm',
      },
    //   'PAST_DATE' : {
    //     colorValues: [
    //     {
    //         backgroundColor : '#DEDEDD',
    //         color : '#000000',
    //         text : '0-0.25'
    //     },
    //     {
    //         backgroundColor : '#D1FCC4',
    //         color : '#000000',
    //         text : '0.25-25'
    //     },
    //     {
    //         backgroundColor : '#97E994',
    //         color : '#000000',
    //         text : '25-65'
    //     },
    //     {
    //         backgroundColor : '#2D9D31',
    //         color : '#FFFFFF',
    //         text : '65-125'
    //     },
    //     {
    //         backgroundColor : '#FDA3A5',
    //         color : '#FFFFFF',
    //         text : '125-250'
    //     },
    //     {
    //         backgroundColor : '#FEBF02',
    //         color : '#FFFFFF',
    //         text : '250-400'
    //     },
    //     {
    //         backgroundColor : '#9C34C7',
    //         color : '#FFFFFF',
    //         text : '400-600'
    //     },
    //     {
    //         backgroundColor : '#951828',
    //         color : '#FFFFFF',
    //         text : '600-1500'
    //     },
    //     {
    //         backgroundColor : '#AFA5FC',
    //         color : '#000000',
    //         text : '1500-2500'
    //     }
    // ],
    // Units : 'Rainfall in mm',
    //   },
      'PAST_DATE' : {
        colorValues: [
        {
            backgroundColor : '#DEDEDD',
            color : '#000000',
            text : '0-100'
        },
        {
            backgroundColor : '#D1FCC4',
            color : '#000000',
            text : '101-250'
        },
        {
            backgroundColor : '#97E994',
            color : '#000000',
            text : '251-500'
        },
        {
            backgroundColor : '#048500',
            color : '#FFFFFF',
            text : '501-750'
        },
        {
            backgroundColor : '#FDA3A5',
            color : '#FFFFFF',
            text : '751-1000'
        },
        {
            backgroundColor : '#FEBF02',
            color : '#FFFFFF',
            text : '1001-2000'
        },
        {
            backgroundColor : '#6BC8D1',
            color : '#FFFFFF',
            text : '2001-3000'
        },
        {
            backgroundColor : '#AFA5FC',
            color : '#FFFFFF',
            text : '3001-4500'
        },
        {
            backgroundColor : '#9C34C7',
            color : '#000000',
            text : '4501-6000'
        }
    ],
    Units : 'Rainfall in mm',
      },
    }

  //    [this.constants.LOW] : [{
  //     "color": "#FC9994 ",
  //     "name": "0-50"
  // }, 
  // {
  //     "color": "#FFC298",
  //     "name": "50-100"
  // },
  // {
  //     "color": "#FFEEA1",
  //     "name": "100-150"
  // },
  // {
  //     "color": "#E6FEB6",
  //     "name": "150-200"
  // }, {
  //     "color": "#BDFEE1",
  //     "name": "200-250"
  // }, {
  //     "color": "#97F5FD",
  //     "name": "250-350"
  // },
  // {
  //     "color": "#9BC2FF",
  //     "name": "350-600"
  // },
  // {
  //     "color": "#9A98FF",
  //     "name": ">600"
  // }],
  // [this.constants.MED] : [{
  //     "color": "#FC9994",
  //     "name": "0-300"
  // }, 
  // {
  //     "color": "#FFC298",
  //     "name": "300-500"
  // },
  // {
  //     "color": "#FFEEA1",
  //     "name": "500-700"
  // },
  // {
  //     "color": "#E6FEB6",
  //     "name": "700-900"
  // }, {
  //     "color": "#BDFEE1",
  //     "name": "900-1500"
  // }, {
  //     "color": "#97F5FD",
  //     "name": "1500-3000"
  // },
  // {
  //     "color": "#9BC2FF",
  //     "name": "3000-3500"
  // },
  // {
  //     "color": "#9A98FF",
  //     "name": ">3500"
  // }],
  // [this.constants.HIGH] : [{
  //     "color": "#FC9994",
  //     "name": "0-1500"
  // }, 
  // {
  //     "color": "#FFC298",
  //     "name": "1500-2000"
  // },
  // {
  //     "color": "#FFEEA1",
  //     "name": "2000-2500"
  // },
  // {
  //     "color": "#E6FEB6",
  //     "name": "2500-3000"
  // }, {
  //     "color": "#BDFEE1",
  //     "name": "3000-3500"
  // }, {
  //     "color": "#97F5FD",
  //     "name": "3500-4000"
  // },
  // {
  //     "color": "#9BC2FF",
  //     "name": "4000-5000"
  // },
  // {
  //     "color": "#9A98FF",
  //     "name": ">5000"
  // }],
    
}

export const LOCTYPE_LAYER_MAPPING = {
  'State' : 'HEATWAVE:ALL_INDIA_STATE',
  'District' : 'HEATWAVE:ALL_INDIA_DISTRICT'
}

export const CQLFILTER_MAPPING = {
    'State' : {
      DISTRICT : 'State_UUID',
      BLOCKS : 'State_UUID'
    },
    'District' : {
      DISTRICT : 'Dist_UUID',
      BLOCKS : 'Dist_UUID'
    }
  }